const SocialIconFacebook = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4539_62)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.6967 2.69694C4.10322 1.29026 6.01088 0.5 8 0.5C9.98912 0.5 11.8968 1.29026 13.3033 2.69694C14.7098 4.10362 15.5 6.01148 15.5 8.00082C15.5 9.99017 14.7098 11.898 13.3033 13.3047C11.9342 14.6739 10.0903 15.4591 8.15869 15.5C8.44891 15.4921 8.73363 15.4636 9.01524 15.4256V9.98943H10.9562L11.2609 8.01751H9.01484V6.93976C9.01484 6.12059 9.28248 5.39419 10.0487 5.39419H11.2798V3.67335L11.2682 3.67177C11.0473 3.64191 10.5908 3.58018 9.74156 3.58018C7.93642 3.58018 6.87813 4.53357 6.87813 6.70565V8.01751H5.02248V9.98943H6.87813V15.4094C7.19132 15.4565 7.50794 15.4907 7.83119 15.4998C5.90321 15.4564 4.06338 14.6715 2.6967 13.3047C1.29018 11.898 0.5 9.99017 0.5 8.00082C0.5 6.01148 1.29018 4.10362 2.6967 2.69694Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4539_62">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { SocialIconFacebook };
